import {DateTime} from 'luxon';
import {RequestMethod} from 'Shared/utilities/fetchHelpers';
import {A360EmployerSummary, Producer} from '../components/A360Commissions/types';
import {fetchA360CommissionsData} from './apiUtils';
import {CommissionsReport} from '../ducks/a360CommissionsReport';
import { extractProducerCodes } from '../components/A360Commissions/utilities';

const A360_COMMMISSIONS_REPORT_ROOT_URI = 'api/commissions/v1';

enum API_ENDPOINT {
  DEFERRED_REPORT = 'commissionsReport/deferred',
  EARNED_ACTIVITY_REPORT = 'commissionsReport/earnedActivity',
  ORDINARY_REPORT = 'commissionsReport/ordinary',
  PRODUCER_FILTER = 'commissionsReport/producerFilter',
}

const buildA360CommissionReportRequestPayload = (agencyCodes?: string[], selectedReportingDate?: DateTime) => {
  return {
    producerCodes: extractProducerCodes(agencyCodes),
    endMonth: selectedReportingDate.toFormat('MM'),
    endYear: selectedReportingDate.toFormat('yyyy'),
  };
};

type RequestPayload = ReturnType<typeof buildA360CommissionReportRequestPayload>;

const fetchDataFromAPI = fetchA360CommissionsData(A360_COMMMISSIONS_REPORT_ROOT_URI);

const getCommissionsReportApiEndpoint = (commissionsReport: CommissionsReport) => {
  switch (commissionsReport) {
    case CommissionsReport.DEFERRED:
      return API_ENDPOINT.DEFERRED_REPORT;
    case CommissionsReport.EARNED_ACTIVITY:
      return API_ENDPOINT.EARNED_ACTIVITY_REPORT;
    case CommissionsReport.ORDINARY:
      return API_ENDPOINT.ORDINARY_REPORT;
    default:
      return '';
  }
};

export default {
  fetchProducerCodesFilterData: async (isNewYork?: boolean) => {
    const producerFilterApiURL = 'commissionStatements/producerFilter';
    const endpoint = `${producerFilterApiURL}?commissionView=reporting&isNewYork=${isNewYork ?? false}`;
    return fetchDataFromAPI<Producer[]>(endpoint, RequestMethod.GET);
  },

  fetchCommissionsReport: async (agencyCodes: string[], selectedDate: DateTime, selectedReport: CommissionsReport) => {
    const requestPayload = buildA360CommissionReportRequestPayload(agencyCodes, selectedDate);
    return fetchDataFromAPI<A360EmployerSummary, RequestPayload>(
      getCommissionsReportApiEndpoint(selectedReport),
      RequestMethod.POST,
      requestPayload
    );
  },
};
